import { API_URL } from '../config/configs';

interface BaseSurveyQuestion {
  id: string;
  label: string;
  required?: boolean;
  showWhen?: SurveyRule;
}

export type SurveyRule =
  | {
      questionId: string;
      operator: 'lte' | 'gte';
      value: number;
    }
  | {
      questionId: string;
      operator: 'eq';
      value: string | number;
    }
  | {
      questionId: string;
      operator: 'between';
      min: number;
      max: number;
    };

export interface RatingSurveyQuestion extends BaseSurveyQuestion {
  type: 'rating';
  min: number;
  max: number;
}

export interface MultipleChoiceSurveyQuestion extends BaseSurveyQuestion {
  type: 'multiple_choice';
  allowMultiple?: boolean;
  options: { id: string; label: string; allowsText?: boolean }[];
}

export interface TextSurveyQuestion extends BaseSurveyQuestion {
  type: 'text';
}

export type SurveyQuestion =
  | RatingSurveyQuestion
  | MultipleChoiceSurveyQuestion
  | TextSurveyQuestion;

export interface SurveyConclusion {
  title?: string;
  message: string;
}

export interface SurveyQuestionTranslation {
  label?: string;
  options?: Record<string, string>;
}

export interface SurveyTranslation {
  conclusions?: Record<string, SurveyConclusion>;
  questions?: Record<string, SurveyQuestionTranslation>;
}

export interface Survey {
  version: string;
  conclusions: Record<string, SurveyConclusion>;
  questions: SurveyQuestion[];
  translations?: Record<string, SurveyTranslation>;
}

export interface SatisfactionSurveyData {
  status: string;
  submittedAt?: string;
  clientName?: string;
  conclusion?: 'positive' | 'neutral' | 'negative';
  survey: Survey;
}

export type SurveyAnswers = Record<string, string | string[] | number>;

export async function getSatisfactionSurvey(
  token: string
): Promise<SatisfactionSurveyData> {
  const res = await fetch(`${API_URL}/satisfaction-surveys/${token}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || 'Erro ao obter questionário');
  return data;
}

export async function submitSatisfactionSurvey(
  token: string,
  answers: SurveyAnswers
) {
  const res = await fetch(`${API_URL}/satisfaction-surveys/${token}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ answers }),
  });

  const data = await res.json();
  if (!res.ok)
    throw new Error(data?.message || 'Erro ao submeter questionário');

  return data;
}
